import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBuilding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.25 4c0-.966.784-1.75 1.75-1.75h12c.966 0 1.75.784 1.75 1.75v16.25H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h1.25V4Zm14 0v16.25h-3.5V15A1.75 1.75 0 0 0 13 13.25h-2A1.75 1.75 0 0 0 9.25 15v5.25h-3.5V4A.25.25 0 0 1 6 3.75h12a.25.25 0 0 1 .25.25Zm-7.5 16.25h2.5V15a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v5.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8 6.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8Zm0 3a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8ZM13.25 7a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14 9.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBuilding;
